export default class LoyaltyService {
  constructor (http, store, router) {
    this.$http = http
    this.$store = store
    this.$router = router
  }

  // ==================== LOYALTY PROGRAMS ====================

  getPrograms () {
    return new Promise((resolve, reject) => {
      this.$http.get('loyalty/programs')
        .then(res => res.data)
        .then(data => {
          resolve(data.data || [])
        })
        .catch(reject)
    })
  }

  getActivePrograms () {
    return new Promise((resolve, reject) => {
      this.$http.get('loyalty/programs/active')
        .then(res => res.data)
        .then(data => {
          resolve(data.data || [])
        })
        .catch(reject)
    })
  }

  getProgram (id) {
    return new Promise((resolve, reject) => {
      this.$http.get(`loyalty/programs/${id}`)
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  createProgram (data) {
    return new Promise((resolve, reject) => {
      this.$http.post('loyalty/programs', data)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  updateProgram (id, data) {
    return new Promise((resolve, reject) => {
      this.$http.post(`loyalty/programs/${id}`, data)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  deleteProgram (id) {
    return new Promise((resolve, reject) => {
      this.$http.delete(`loyalty/programs/${id}`)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data)
        })
        .catch(reject)
    })
  }

  // ==================== LOYALTY TIERS ====================

  getTiers (programId) {
    return new Promise((resolve, reject) => {
      this.$http.get(`loyalty/programs/${programId}/tiers`)
        .then(res => res.data)
        .then(data => {
          resolve(data.data || [])
        })
        .catch(reject)
    })
  }

  getTier (id) {
    return new Promise((resolve, reject) => {
      this.$http.get(`loyalty/tiers/${id}`)
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  createTier (data) {
    return new Promise((resolve, reject) => {
      this.$http.post('loyalty/tiers', data)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  updateTier (id, data) {
    return new Promise((resolve, reject) => {
      this.$http.post(`loyalty/tiers/${id}`, data)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  deleteTier (id) {
    return new Promise((resolve, reject) => {
      this.$http.delete(`loyalty/tiers/${id}`)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data)
        })
        .catch(reject)
    })
  }

  // ==================== LOYALTY REWARDS ====================

  getRewards (programId) {
    return new Promise((resolve, reject) => {
      this.$http.get(`loyalty/programs/${programId}/rewards`)
        .then(res => res.data)
        .then(data => {
          resolve(data.data || [])
        })
        .catch(reject)
    })
  }

  getAvailableRewards (programId) {
    return new Promise((resolve, reject) => {
      this.$http.get(`loyalty/programs/${programId}/rewards/available`)
        .then(res => res.data)
        .then(data => {
          resolve(data.data || [])
        })
        .catch(reject)
    })
  }

  getReward (id) {
    return new Promise((resolve, reject) => {
      this.$http.get(`loyalty/rewards/${id}`)
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  createReward (data) {
    return new Promise((resolve, reject) => {
      this.$http.post('loyalty/rewards', data)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  updateReward (id, data) {
    return new Promise((resolve, reject) => {
      this.$http.post(`loyalty/rewards/${id}`, data)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  deleteReward (id) {
    return new Promise((resolve, reject) => {
      this.$http.delete(`loyalty/rewards/${id}`)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data)
        })
        .catch(reject)
    })
  }

  // ==================== EARNING RULES ====================

  getEarningRules (programId) {
    return new Promise((resolve, reject) => {
      this.$http.get(`loyalty/programs/${programId}/earning-rules`)
        .then(res => res.data)
        .then(data => {
          resolve(data.data || [])
        })
        .catch(reject)
    })
  }

  getEarningRule (id) {
    return new Promise((resolve, reject) => {
      this.$http.get(`loyalty/earning-rules/${id}`)
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  createEarningRule (data) {
    return new Promise((resolve, reject) => {
      this.$http.post('loyalty/earning-rules', data)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  updateEarningRule (id, data) {
    return new Promise((resolve, reject) => {
      this.$http.post(`loyalty/earning-rules/${id}`, data)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  deleteEarningRule (id) {
    return new Promise((resolve, reject) => {
      this.$http.delete(`loyalty/earning-rules/${id}`)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data)
        })
        .catch(reject)
    })
  }

  // ==================== CUSTOMER LOYALTY ====================

  getCustomerSummary (customerId, programId = null) {
    return new Promise((resolve, reject) => {
      const params = programId ? { program_id: programId } : {}
      this.$http.get(`loyalty/customers/${customerId}/summary`, { params })
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  getCustomerTransactions (customerId, params = {}) {
    return new Promise((resolve, reject) => {
      this.$http.get(`loyalty/customers/${customerId}/transactions`, { params })
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  getCustomerAvailableRewards (customerId, programId) {
    return new Promise((resolve, reject) => {
      this.$http.get(`loyalty/customers/${customerId}/rewards/available`, {
        params: { program_id: programId }
      })
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  adjustCustomerPoints (customerId, data) {
    return new Promise((resolve, reject) => {
      this.$http.post(`loyalty/customers/${customerId}/adjust-points`, data)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  redeemReward (customerId, data) {
    return new Promise((resolve, reject) => {
      this.$http.post(`loyalty/customers/${customerId}/redeem`, data)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }
}
